import { render } from "./website.vue?vue&type=template&id=2ed5a65c"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/website.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ed5a65c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ed5a65c', __exports__)) {
    console.log('reload')
    api.reload('2ed5a65c', __exports__)
  }
  
  module.hot.accept("./website.vue?vue&type=template&id=2ed5a65c", () => {
    console.log('re-render')
    api.rerender('2ed5a65c', render)
  })

}


export default __exports__